module.exports = __webpack_public_path__ + "img/business-type-restaurant.4753f6e.png";